<nz-card class="custom-card with-point">
  <div class="custom-card_body">
    <span>Punti attuali fino ad oggi</span>
    <div class="score">1500pt</div>
  </div>

  <div class="custom-card_footer">
    <div>Achievement</div>
    <div>
      <img
        class="project-img"
        src="assets/images/medal.png"
        alt=""
        nz-tooltip
        nzTooltipTitle="Test"
        nzTooltipPlacement="top" />
      <img
        class="project-img"
        src="assets/images/medal.png"
        alt=""
        nz-tooltip
        nzTooltipTitle="Test"
        nzTooltipPlacement="top" />
    </div>
  </div>

  <div class="custom-card_point">Lv 13</div>
</nz-card>
